import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    title: 'title'               the name show in submenu and breadcrumb (recommend set)
    icon: 'svg-name'             the icon show in the sidebar,
  }
 **/
export const constantRouterMap = [
  { path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/404', component: () => import('@/views/404'), hidden: true },

  {
    path: '',
    component: Layout,
    redirect: '/home',
    meta: { title: '首页', icon: 'home' },
    children: [{
      path: 'home',
      name: 'home',
      component: () => import('@/views/home/index'),
      meta: { title: '仪表盘', icon: 'dashboard' }
    },
    {
      name: 'document',
      path: 'https://www.macrozheng.com',
      meta: { title: '学习教程', icon: 'document' }
    },
    {
      name: 'video',
      path: 'https://www.macrozheng.com/mall/catalog/mall_video.html',
      meta: { title: '视频教程', icon: 'video' }
    },
    ]
  }
]

export const asyncRouterMap = [
  {
    path: '/pms',
    component: Layout,
    redirect: '/pms/product',
    name: 'pms',
    meta: { title: '营销管理', icon: 'product' },
    children: [,
        {
          path: 'advisement',
          name: 'advisement',
          component: () => import('@/views/pms/advisement/advisementList'),
          meta: { title: '广告列表', }
        },
        {
          path: 'liveschedule',
          name: 'liveschedule',
          component: () => import('@/views/pms/liveschedule/index'),
          meta: { title: '直播管理', }
        },
        {
          path: 'product',
          name: 'product',
          component: () => import('@/views/pms/product/index'),
          meta: {title: '商品列表', icon: 'product-list'}
        },
        {
          path: 'addProduct',
          name: 'addProduct',
          component: () => import('@/views/pms/product/add'),
          meta: {title: '添加商品', icon: 'product-add'}
        },
        {
          path: 'updateProduct',
          name: 'updateProduct',
          component: () => import('@/views/pms/product/update'),
          meta: {title: '修改商品', icon: 'product-add'},
          hidden: true
        },
        {
          path: 'productCate',
          name: 'productCate',
          component: () => import('@/views/pms/productCate/index'),
          meta: {title: '商品分类', icon: 'product-cate'}
        },
        {
          path: 'addProductCate',
          name: 'addProductCate',
          component: () => import('@/views/pms/productCate/add'),
          meta: {title: '添加商品分类'},
          hidden: true
        },
        {
          path: 'updateProductCate',
          name: 'updateProductCate',
          component: () => import('@/views/pms/productCate/update'),
          meta: {title: '修改商品分类'},
          hidden: true
        },
        {
          path: 'productAttr',
          name: 'productAttr',
          component: () => import('@/views/pms/productAttr/index'),
          meta: {title: '商品类型', icon: 'product-attr'}
        },
        {
          path: 'productAttrList',
          name: 'productAttrList',
          component: () => import('@/views/pms/productAttr/productAttrList'),
          meta: {title: '商品属性列表'},
          hidden: true
        },
        {
          path: 'addProductAttr',
          name: 'addProductAttr',
          component: () => import('@/views/pms/productAttr/addProductAttr'),
          meta: {title: '添加商品属性'},
          hidden: true
        },
        {
          path: 'updateProductAttr',
          name: 'updateProductAttr',
          component: () => import('@/views/pms/productAttr/updateProductAttr'),
          meta: {title: '修改商品属性'},
          hidden: true
        },
        {
          path: 'brand',
          name: 'brand',
          component: () => import('@/views/pms/brand/index'),
          meta: {title: '品牌管理', icon: 'product-brand'}
        },
        {
          path: 'addBrand',
          name: 'addBrand',
          component: () => import('@/views/pms/brand/add'),
          meta: {title: '添加品牌'},
          hidden: true
        },
        {
          path: 'updateBrand',
          name: 'updateBrand',
          component: () => import('@/views/pms/brand/update'),
          meta: {title: '编辑品牌'},
          hidden: true
        }
    ]
  },
  {
    path: '/oms',
    component: Layout,
    redirect: '/oms/order',
    name: 'oms',
    meta: {title: '订单', icon: 'order'},
    children: [
      {
        path: 'order',
        name: 'order',
        component: () => import('@/views/oms/order/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
      {
        path: 'orderDetail',
        name: 'orderDetail',
        component: () => import('@/views/oms/order/orderDetail'),
        meta: {title: '订单详情'},
        hidden:true
      },
      {
        path: 'deliverOrderList',
        name: 'deliverOrderList',
        component: () => import('@/views/oms/order/deliverOrderList'),
        meta: {title: '发货列表'},
        hidden:true
      },
      {
        path: 'orderSetting',
        name: 'orderSetting',
        component: () => import('@/views/oms/order/setting'),
        meta: {title: '订单设置', icon: 'order-setting'}
      },
      {
        path: 'returnApply',
        name: 'returnApply',
        component: () => import('@/views/oms/apply/index'),
        meta: {title: '退货申请处理', icon: 'order-return'}
      },
      {
        path: 'returnReason',
        name: 'returnReason',
        component: () => import('@/views/oms/apply/reason'),
        meta: {title: '退货原因设置', icon: 'order-return-reason'}
      },
      {
        path: 'returnApplyDetail',
        name: 'returnApplyDetail',
        component: () => import('@/views/oms/apply/applyDetail'),
        meta: {title: '退货原因详情'},
        hidden:true
      },
      {
        path: 'withdrawal-review',
        name: 'withdrawal-review',
        component: () => import('@/views/oms/withdrawal-review/index'),
        meta: {title: '订单列表', icon: 'product-list'}
      },
    ]
  },
  {
    path: '/asp',
    component: Layout,
    redirect: '/asp/user',
    name: 'asp',
    meta: { title: '用户管理', icon: 'order-setting' },
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/asp/user'),
        meta: { title: '用户列表', icon: 'product-list' }
      },
      {
        path: 'salesman',
        name: 'salesman',
        component: () => import('@/views/asp/salesman/salesman'),
        meta: { title: '销售人员管理', icon: 'ums-resource' }
      },
      {
        path: 'master',
        name: 'master',
        component: () => import('@/views/asp/master'),
        meta: { title: '大师管理', icon: 'ums-resource' }
      },
    ]
  },
  {
    path: '/art',
    component: Layout,
    redirect: '/art/article',
    name: 'art',
    meta: { title: '文章管理', icon: 'order-setting' },
    children: [
      {
        path: 'article',
        name: 'article',
        component: () => import('@/views/art/article/classroom'),
        meta: { title: '易学课堂', icon: 'product-list' }
      },
      {
        path: 'case',
        name: 'case',
        component: () => import('@/views/art/case/caseList'),
        meta: { title: '案例列表', icon: 'product-list' }
      },
      {
        path: 'anci',
        name: 'anci',
        component: () => import('@/views/art/anci/ancient'),
        meta: { title: '古籍列表', icon: 'product-list' }
      },
    ]
  },
  {
    path: '/ana',
    component: Layout,
    redirect: '/ana/analysic',
    name: 'ana',
    meta: { title: '解析管理', icon: 'order-setting' },
    children: [
      {
        path: 'analysic',
        name: 'analysic',
        component: () => import('@/views/ana/analysic/invisible'),
        meta: { title: '奇门遁甲', icon: 'product-list' }
      },

      {
        path: 'ziv',
        name: 'ziv',
        component: () => import('@/views/ana/ziv/ziwei'),
        meta: { title: '紫微斗数', icon: 'product-list' }
      },
      {
        path: 'sixy',
        name: 'sixy',
        component: () => import('@/views/ana/sixy/sixyao'),
        meta: { title: '六爻', icon: 'product-list' }
      },
      {
        path: 'map',
        name: 'map',
        component: () => import('@/views/ana/map/smallmap'),
        meta: { title: '小成图', icon: 'product-list' }
      },
      {
        path: 'flower',
        name: 'flower',
        component: () => import('@/views/ana/flower/plumflower'),
        meta: { title: '梅花', icon: 'product-list' }
      },
      {
        path: 'eight',
        name: 'eight',
        component: () => import('@/views/ana/eight/character'),
        meta: { title: '八字', icon: 'product-list' }
      },
      {
        path: 'fortune',
        name: 'fortune',
        component: () => import('@/views/ana/fortune/fortunetell'),
        meta: { title: '金口诀', icon: 'product-list' }
      },
      {
        path: 'formu',
        name: 'formu',
        component: () => import('@/views/ana/formu/formula'),
        meta: { title: '大六壬', icon: 'product-list' }
      },

    ]
  },
  {
    path: '/sal',
    component: Layout,
    redirect: '/asp/sale',
    name: 'sal',
    meta: { title: '销售管理', icon: 'order-setting' },
    children: [
    ],
  },
  {
    path: '/prod',
    component: Layout,
    redirect: '/prod/prod',
    name: 'prod',
    meta: { title: '商品管理', icon: 'order-setting' },
    children: [
      {
        path: 'prod',
        name: 'prod',
        component: () => import('@/views/prod/prod/prod'),
        meta: { title: '商品管理', icon: 'product-list' }
      },
      {
        path: 'spec',
        name: 'spec',
        component: () => import('@/views/prod/spec/spec'),
        meta: { title: '规格管理', icon: 'product-list' }
      }
    ]
  },
  {
    path: '/tcm',
    component: Layout,
    redirect: '/tcm',
    name: 'tcm',
    meta: { title: '中医管理', icon: 'order-setting' },
    children: [
     {
        path: 'tcmmodule',
         name: 'tcmmodule',
        component: () => import('@/views/tcm/tcmmodule'),
        meta: { title: '模块管理', icon: 'product-list' }
      },
      {
        path: 'tcmtype',
         name: 'tcmtype',
        component: () => import('@/views/tcm/tcmtype'),
        meta: { title: '模块类型管理', icon: 'product-list' }
      },
      {
        path: 'tcmmeridians',
         name: 'tcmmeridians',
        component: () => import('@/views/tcm/tcmmeridians'),
        meta: { title: '经络管理', icon: 'product-list' }
      },
      {
        path: 'tcmacupoint',
         name: 'tcmacupoint',
        component: () => import('@/views/tcm/tcmacupoint'),
        meta: { title: '穴位管理', icon: 'product-list' }
      },
      {
        path: 'tcmdisease',
         name: 'tcmdisease',
        component: () => import('@/views/tcm/tcmdisease'),
        meta: { title: '病症管理', icon: 'product-list' }
      },
      {
        path: 'tcmdrug',
         name: 'tcmdrug',
        component: () => import('@/views/tcm/tcmdrug'),
        meta: { title: '中药管理', icon: 'product-list' }
      },
      {
        path: 'tcmprescription',
         name: 'tcmprescription',
        component: () => import('@/views/tcm/tcmprescription'),
        meta: { title: '方剂管理', icon: 'product-list' }
      },
      {
        path: 'tcmbasewords',
         name: 'tcmbasewords',
        component: () => import('@/views/tcm/tcmbasewords'),
        meta: { title: '基础词条管理', icon: 'product-list' }
      },
      {
        path: 'tcmbook',
         name: 'tcmbook',
        component: () => import('@/views/tcm/tcmbook'),
        meta: { title: '中医书籍管理', icon: 'product-list' }
      },
      {
        path: 'tcmarticles',
         name: 'tcmarticles',
        component: () => import('@/views/tcm/tcmarticles'),
        meta: { title: '文章内容管理', icon: 'product-list' }
      },
      {
        path: 'tcmquestion',
         name: 'tcmquestion',
        component: () => import('@/views/tcm/tcmquestion'),
        meta: { title: '答题题目管理', icon: 'product-list' }
      },
    ]
  },
  {
    path: '/sys',
    component: Layout,
    redirect: '/asp/artsub',
    name: 'sys',
    meta: { title: '系统管理', icon: 'order-setting' },
    children: [
      {
        path: 'artsub',
        name: 'artsub',
        component: () => import('@/views/sys/artsub/artsubject'),
        meta: { title: '文章科目', icon: 'product-list' }
      },
      {
        path: 'cate',
        name: 'cate',
        component: () => import('@/views/sys/cate/category'),
        meta: { title: '文章分类', icon: 'product-list' }
      },
      {
        path: 'infor',
        name: 'infor',
        component: () => import('@/views/sys/infor/information'),
        meta: { title: '信息导入', icon: 'product-list' }
      },
      {
        path: 'vip',
        name: 'vip',
        component: () => import('@/views/sys/vip/member'),
        meta: { title: '会员配置', icon: 'product-list' }
      },
      {
        path: 'feed',
        name: 'feed',
        component: () => import('@/views/sys/feed/feedback'),
        meta: { title: '客户反馈', icon: 'product-list' }
      },

      {
        path: 'ren',
        name: 'ren',
        component: () => import('@/views/sys/ren/renew'),
        meta: { title: '版本更新', icon: 'product-list' }
      },
      {
        path: 'class',
        name: 'class',
        component: () => import('@/views/sys/class/video'),
        meta: { title: '视频管理', icon: 'product-list' }
      },
      {
        path: 'whiteList',
        name: 'whiteList',
        component: () => import('@/views/sys/whiteList/whiteList'),
        meta: { title: '白名单', icon: 'ums-resource' }
      },
      {
        path: 'carouselVideo',
        name: 'carouselVideo',
        component: () => import('@/views/sys/carouselVideo/carouselVideo'),
        meta: { title: '轮播视频', icon: 'video' }
      },
      {
        path: 'collectionVideo',
        name: 'collectionVideo',
        component: () => import('@/views/sys/collectionVideo/collectionVideo'),
        meta: { title: '合集视频信息', icon: 'video' }
      },
      {
        path: 'colVideo',
        name: 'colVideo',
        component: () => import('@/views/sys/colVideo/colVideo'),
        meta: { title: '合集视频', icon: 'video' }
      },
      {
        path: 'collectionVideobuy',
        name: 'collectionVideobuy',
        component: () => import('@/views/sys/collectionVideobuy/collectionVideobuy'),
        meta: { title: '合集视频购买', icon: 'video' }
      },
      {
        path: 'inviteNew',
        name: 'inviteNew',
        component: () => import('@/views/sys/inviteNew/inviteNew'),
        meta: { title: '邀新信息', icon: 'ums-resource' }
      },
      {
        path: 'answerManage',
        name: 'answerManage',
        component: () => import('@/views/sys/answerManage/answerManage'),
        meta: { title: '答题管理', icon: 'order' }
      },
      {
        path: 'carouselCollection',
        name: 'carouselCollection',
        component: () => import('@/views/sys/carouselCollection/carouselCollection'),
        meta: { title: '合集广告轮播图', icon: 'video' }
      }
    ],
  },
  //
  {
    path: '/ums',
    component: Layout,
    redirect: '/ums/admin',
    name: 'ums',
    meta: { title: '权限', icon: 'ums' },
    children: [
      {
        path: 'admin',
        name: 'admin',
        component: () => import('@/views/ums/admin/index'),
        meta: { title: '用户列表', icon: 'ums-admin' }
      },
      {
        path: 'role',
        name: 'role',
        component: () => import('@/views/ums/role/index'),
        meta: { title: '角色列表', icon: 'ums-role' }
      },
      {
        path: 'allocMenu',
        name: 'allocMenu',
        component: () => import('@/views/ums/role/allocMenu'),
        meta: { title: '分配菜单' },
        hidden: true
      },
      {
        path: 'allocResource',
        name: 'allocResource',
        component: () => import('@/views/ums/role/allocResource'),
        meta: { title: '分配资源' },
        hidden: true
      },
      {
        path: 'menu',
        name: 'menu',
        component: () => import('@/views/ums/menu/index'),
        meta: { title: '菜单列表', icon: 'ums-menu' }
      },
      {
        path: 'addMenu',
        name: 'addMenu',
        component: () => import('@/views/ums/menu/add'),
        meta: { title: '添加菜单' },
        hidden: true
      },
      {
        path: 'updateMenu',
        name: 'updateMenu',
        component: () => import('@/views/ums/menu/update'),
        meta: { title: '修改菜单' },
        hidden: true
      },
      {
        path: 'resource',
        name: 'resource',
        component: () => import('@/views/ums/resource/index'),
        meta: { title: '资源列表', icon: 'ums-resource' }
      },
      {
        path: 'resourceCategory',
        name: 'resourceCategory',
        component: () => import('@/views/ums/resource/categoryList'),
        meta: { title: '资源分类' },
        hidden: true
      }
    ]
  },
  { path: '*', redirect: '/404', hidden: true }
]

export default new Router({
  // mode: 'history', //后端支持可开
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
})




// WEBPACK FOOTER //
// ./src/router/index.js